var _path, _rect, _line, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 7.8C3.66797 5.14903 5.817 3 8.46797 3H24.868C27.5189 3 29.668 5.14903 29.668 7.8V11H3.66797V7.8Z",
    fill: "#F5DADF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.66797,
    y: 3,
    width: 26,
    height: 26,
    rx: 4,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.86719,
    y1: 11,
    x2: 28.6672,
    y2: 11,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5683 22.478C13.7243 23.999 14.9203 25.104 16.6103 25.104C18.3653 25.104 19.6913 23.934 19.6913 22.049C19.6913 20.45 18.8333 19.345 17.4293 19.345C17.2733 19.345 17.1823 19.358 17.0653 19.371L19.2103 16.472V15.9H13.9973V17.408H16.8963L15.1803 19.761L15.8303 20.671C16.1033 20.528 16.3373 20.476 16.6233 20.476C17.4423 20.476 18.0533 21.022 18.0533 22.075C18.0533 23.011 17.4553 23.596 16.6103 23.596C15.7913 23.596 15.3363 23.076 15.1413 22.27L13.5683 22.478Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.28ae33e72c2a5a581cdf8ed2ed8e03b7.svg";
export { ForwardRef as ReactComponent };